export default __webpack_public_path__ + "images/f4b38fd95f00b849ac0fe43466bb22a7.svg";